import { IonButton, IonIcon } from '@ionic/react';
import { arrowForwardOutline, checkmarkCircleOutline, giftOutline, logoWhatsapp } from 'ionicons/icons';
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import CadastroLayout from '../CadastroLayout/CadastroLayout';
import './LoginConvite.css';

const LoginConvite: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const convite = new URLSearchParams(location.search).get('convite') || '';
  const isMercadoLivre = convite.toLowerCase() === 'ml';
  // Preserve the existing invitation rules, including the Mercado Livre offer.
  const desconto = convite.endsWith('20') ? 20 : convite.endsWith('50') ? 50 : isMercadoLivre || convite.endsWith('75') ? 75 : 0;
  const continuar = () => history.push('/tipoconta' + (convite ? '?convite=' + encodeURIComponent(convite) : ''));
  const suporte = () => {
    const mensagem = `Olá, recebi o convite ${convite}. Gostaria de obter mais informações sobre o sistema XEGUEI que vocês oferecem. Poderiam me ajudar?`;
    window.open('https://api.whatsapp.com/send?phone=5511963927646&text=' + encodeURIComponent(mensagem), '_blank', 'noopener,noreferrer');
  };

  return (
    <CadastroLayout headerTitle="Seu convite" title={isMercadoLivre ? 'Oferta exclusiva Mercado Livre' : 'Você recebeu um convite'} description="Comece a usar o Xeguei e aproveite as condições do seu convite." backHref="/login" icon={giftOutline} badge="Convite Xeguei">
      <div className="convite-layout">
        <section className="convite-offer" aria-labelledby="convite-offer-title">
          <span className="convite-offer-icon"><IonIcon icon={giftOutline} aria-hidden="true" /></span>
          <span className="convite-eyebrow">{desconto > 0 ? 'UMA CONDIÇÃO ESPECIAL PARA VOCÊ' : 'SEU PRÓXIMO PASSO'}</span>
          <h2 id="convite-offer-title">{desconto > 0 ? <><strong>{desconto}<span>%</span></strong><span className="convite-discount-label">de desconto</span></> : 'Seu negócio no Xeguei'}</h2>
          <p className="convite-offer-subtitle">{desconto > 0 ? 'Em todas as mensalidades!' : 'Crie sua conta e comece a usar o sistema.'}</p>
          <p className="convite-offer-description">{desconto > 0 ? 'Aproveite nossa oferta especial por tempo limitado.' : 'Continue para escolher seu tipo de conta e preencher seus dados.'}</p>
          {convite && <div className="convite-code"><span>Seu convite</span><strong>{convite}</strong><IonIcon icon={checkmarkCircleOutline} aria-hidden="true" /></div>}
          <IonButton className="cadastro-primary" expand="block" onClick={continuar}>{isMercadoLivre ? 'Continuar' : 'Testar grátis por 7 dias'}<IonIcon slot="end" icon={arrowForwardOutline} /></IonButton>
          <p className="convite-carry-note">{convite ? 'Seu convite acompanha você nas próximas etapas.' : 'Cadastre-se como autônomo ou empresa.'}</p>
        </section>
        <aside className="convite-side">
          <section className="convite-guide" aria-labelledby="convite-guide-title">
            <h2 id="convite-guide-title">Comece em poucos passos</h2>
            <p>Vamos ajudar você a criar sua conta.</p>
            <ol>
              <li><span>1</span><div><h3>Escolha o tipo de conta</h3><p>Autônomo com CPF ou empresa com CNPJ.</p></div></li>
              <li><span>2</span><div><h3>Preencha seus dados</h3><p>Informe seus contatos, endereço e área de atuação.</p></div></li>
              <li><span>3</span><div><h3>Acesse sua conta</h3><p>Depois do cadastro, comece a configurar seu negócio no Xeguei.</p></div></li>
            </ol>
          </section>
          <section className="convite-support">
            <span className="convite-support-icon"><IonIcon icon={logoWhatsapp} aria-hidden="true" /></span>
            <div><h2>Ficou com alguma dúvida?</h2><p>Converse com nossa equipe sobre o sistema e seu convite.</p></div>
            <IonButton fill="outline" onClick={suporte}><IonIcon slot="start" icon={logoWhatsapp} />Falar no WhatsApp</IonButton>
          </section>
        </aside>
      </div>
    </CadastroLayout>
  );
};

export default LoginConvite;
